import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { LunchDayCell } from './LunchDayCell';
import { decimalFormatter } from '../../components/Table/utility';
import { forwardRef, useState, useEffect } from 'react';
import { DayHeaderCell } from '../../components/Cells/CalendarTable/DayHeaderCell';
import { Formik } from 'formik';

const LunchesTable = forwardRef((props, ref) => {
  const {
    dayHeaders,
    data,
    isReadOnly,
    onAddClick,
    onEditClick,
    onDeleteClick,
    onScroll,
  } = props;

  // Internal state for UI data that gets updated when lunches change
  const [lunchData, setLunchData] = useState(data);

  // Sync internal state with prop changes
  useEffect(() => {
    setLunchData(data);
  }, [data]);

  // Count the number of offered lunches from internal state
  const offeredCount = lunchData.filter(lunch => lunch.offered).length;

  // Handle lunch updates from child components
  const handleLunchUpdate = (date, updatedLunchData) => {
    setLunchData(prevLunches => {
      const existingIndex = prevLunches.findIndex(lunch => lunch.date === date);
      
      if (existingIndex >= 0) {
        // Update existing lunch
        const newLunches = [...prevLunches];
        newLunches[existingIndex] = updatedLunchData;
        return newLunches;
      }
      // Add new lunch
      return [...prevLunches, updatedLunchData];
    });
  };

  return (
    <Formik initialValues={{}} onSubmit={() => {}}>
      <TableContainer component={Paper} onScroll={onScroll} ref={ref}>
        <Table stickyHeader className="month-table">
          <TableHead>
            <TableRow>
              <TableCell>Pranzo offerto</TableCell>
              <TableCell>QT.</TableCell>
              {dayHeaders.map((header) => (
                <DayHeaderCell
                  day={header.day}
                  isWeekEnd={header.weekEnd}
                  isHoliday={header.isHolidays}
                  isToday={header.isToday}
                  key={header.day.format('DD')}
                />
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow key="id-lunch">
              <TableCell />
              <TableCell>{decimalFormatter.format(offeredCount)}</TableCell>
              {dayHeaders.map((header) => {
                const date = header.day.format('YYYY-MM-DD');
                const cellData = lunchData.find((i) => i.date === date);
                return (
                  <LunchDayCell
                    data={cellData}
                    date={date}
                    isReadOnly={isReadOnly}
                    isEmbeddedInWorklog={true}
                    isWeekEnd={header.weekEnd}
                    isHoliday={header.isHolidays}
                    isToday={header.isToday}
                    onLunchUpdate={handleLunchUpdate}
                    onAddClick={onAddClick}
                    onEditClick={onEditClick}
                    onDeleteClick={onDeleteClick}
                    key={date}
                  />
                );
              })}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Formik>
  );
});

LunchesTable.defaultProps = {
  dayHeaders: [],
  data: [],
  isReadOnly: false,
  onAddClick: () => {},
  onEditClick: () => {},
  onDeleteClick: () => {},
  onScroll: () => {},
};

LunchesTable.propTypes = {
  dayHeaders: PropTypes.instanceOf(Array),
  data: PropTypes.instanceOf(Array),
  isReadOnly: PropTypes.bool,
  onAddClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onScroll: PropTypes.func,
};

LunchesTable.displayName = 'LunchesTable';
export default LunchesTable;
